import React from 'react'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { FormHelperText } from '@mui/material'

const SutureType = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Suture Type</InputLabel>
      <Select
        value={moduleValues?.['Suture Type'] ?? ''}
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Suture Type']: e.target.value,
          }))
        }
        label="Suture Type"
      >
        <MenuItem value="Absorbable">Absorbable (e.g., Vicryl)</MenuItem>
        <MenuItem value="Non-Absorbable">Non-Absorbable (e.g., Nylon)</MenuItem>
        <MenuItem value="Monofilament">Monofilament</MenuItem>
        <MenuItem value="Braided">Braided</MenuItem>
      </Select>
    </FormControl>
  </Grid>
)

export default SutureType
